import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Governance } from "@/features/governance/modules/governance/governance";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/governance/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.governance_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={ShieldCheck} title={m.governance_title()} description={m.governance_description()}>
      <Governance />
    </PageShell>
  );
}
